/**
 * NGBMS Media Mgmt
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { V1GetAllButtonDownloadStatusGet200Response } from '../model/v1GetAllButtonDownloadStatusGet200Response';
// @ts-ignore
import { V1GetAllVideosGet200Response } from '../model/v1GetAllVideosGet200Response';
// @ts-ignore
import { V1GetButtonStatusVehicleNumGet200Response } from '../model/v1GetButtonStatusVehicleNumGet200Response';
// @ts-ignore
import { V1GetVideoDownloadStatusVehicleNumGet200Response } from '../model/v1GetVideoDownloadStatusVehicleNumGet200Response';
// @ts-ignore
import { V1GetVideoToPlayGet200Response } from '../model/v1GetVideoToPlayGet200Response';
// @ts-ignore
import { V1SendButtonStatusVideoIdVehicleNumPost200Response } from '../model/v1SendButtonStatusVideoIdVehicleNumPost200Response';
// @ts-ignore
import { V1SendButtonStatusVideoIdVehicleNumPostRequest } from '../model/v1SendButtonStatusVideoIdVehicleNumPostRequest';
// @ts-ignore
import { V1UpdateFlagOfVideoVideoIdPost200Response } from '../model/v1UpdateFlagOfVideoVideoIdPost200Response';
// @ts-ignore
import { V1UpdateFlagOfVideoVideoIdPostRequest } from '../model/v1UpdateFlagOfVideoVideoIdPostRequest';
// @ts-ignore
import { V1UpdateVideoDownloadStatusVideoNameVehicleNumPost200Response } from '../model/v1UpdateVideoDownloadStatusVideoNameVehicleNumPost200Response';
// @ts-ignore
import { V1UpdateVideoDownloadStatusVideoNameVehicleNumPostRequest } from '../model/v1UpdateVideoDownloadStatusVideoNameVehicleNumPostRequest';
// @ts-ignore
import { V1UploadVideoPost200Response } from '../model/v1UploadVideoPost200Response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { MediaMgmtConfiguration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class NgbmsMediaMgmtService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new MediaMgmtConfiguration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: MediaMgmtConfiguration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Delete video
     * @param videoId 
     * @param loggedInUser 
     * @param ctryCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1DeleteVideoIdDelete(videoId: number, loggedInUser?: string, ctryCode?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<object>;
    public v1DeleteVideoIdDelete(videoId: number, loggedInUser?: string, ctryCode?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<object>>;
    public v1DeleteVideoIdDelete(videoId: number, loggedInUser?: string, ctryCode?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<object>>;
    public v1DeleteVideoIdDelete(videoId: number, loggedInUser?: string, ctryCode?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (videoId === null || videoId === undefined) {
            throw new Error('Required parameter videoId was null or undefined when calling v1DeleteVideoIdDelete.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (loggedInUser !== undefined && loggedInUser !== null) {
            localVarHeaders = localVarHeaders.set('logged-in-user', String(loggedInUser));
        }
        if (ctryCode !== undefined && ctryCode !== null) {
            localVarHeaders = localVarHeaders.set('ctry-code', String(ctryCode));
        }

        let localVarCredential: string | undefined;
        // authentication (bearer) required
        localVarCredential = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/delete/${this.configuration.encodeParam({name: "videoId", value: videoId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        return this.httpClient.request<object>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Download video
     * Download the latest video to be played
     * @param loggedInUser 
     * @param ctryCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1DownloadVideoGet(loggedInUser?: string, ctryCode?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<object>;
    public v1DownloadVideoGet(loggedInUser?: string, ctryCode?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<object>>;
    public v1DownloadVideoGet(loggedInUser?: string, ctryCode?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<object>>;
    public v1DownloadVideoGet(loggedInUser?: string, ctryCode?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;
        if (loggedInUser !== undefined && loggedInUser !== null) {
            localVarHeaders = localVarHeaders.set('logged-in-user', String(loggedInUser));
        }
        if (ctryCode !== undefined && ctryCode !== null) {
            localVarHeaders = localVarHeaders.set('ctry-code', String(ctryCode));
        }

        let localVarCredential: string | undefined;
        // authentication (bearer) required
        localVarCredential = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/downloadVideo`;
        return this.httpClient.request<object>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get All Button and Download Status
     * @param loggedInUser 
     * @param ctryCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1GetAllButtonDownloadStatusGet(loggedInUser?: string, ctryCode?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<V1GetAllButtonDownloadStatusGet200Response>;
    public v1GetAllButtonDownloadStatusGet(loggedInUser?: string, ctryCode?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<V1GetAllButtonDownloadStatusGet200Response>>;
    public v1GetAllButtonDownloadStatusGet(loggedInUser?: string, ctryCode?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<V1GetAllButtonDownloadStatusGet200Response>>;
    public v1GetAllButtonDownloadStatusGet(loggedInUser?: string, ctryCode?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;
        if (loggedInUser !== undefined && loggedInUser !== null) {
            localVarHeaders = localVarHeaders.set('logged-in-user', String(loggedInUser));
        }
        if (ctryCode !== undefined && ctryCode !== null) {
            localVarHeaders = localVarHeaders.set('ctry-code', String(ctryCode));
        }

        let localVarCredential: string | undefined;
        // authentication (bearer) required
        localVarCredential = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/getAllButtonDownloadStatus`;
        return this.httpClient.request<V1GetAllButtonDownloadStatusGet200Response>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Video List
     * @param loggedInUser 
     * @param ctryCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1GetAllVideosGet(loggedInUser?: string, ctryCode?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<V1GetAllVideosGet200Response>;
    public v1GetAllVideosGet(loggedInUser?: string, ctryCode?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<V1GetAllVideosGet200Response>>;
    public v1GetAllVideosGet(loggedInUser?: string, ctryCode?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<V1GetAllVideosGet200Response>>;
    public v1GetAllVideosGet(loggedInUser?: string, ctryCode?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;
        if (loggedInUser !== undefined && loggedInUser !== null) {
            localVarHeaders = localVarHeaders.set('logged-in-user', String(loggedInUser));
        }
        if (ctryCode !== undefined && ctryCode !== null) {
            localVarHeaders = localVarHeaders.set('ctry-code', String(ctryCode));
        }

        let localVarCredential: string | undefined;
        // authentication (bearer) required
        localVarCredential = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/getAllVideos`;
        return this.httpClient.request<V1GetAllVideosGet200Response>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Button Status
     * Bus device get button status from portal based on vehicle number
     * @param vehicleNum 
     * @param loggedInUser 
     * @param ctryCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1GetButtonStatusVehicleNumGet(vehicleNum: string, loggedInUser?: string, ctryCode?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<V1GetButtonStatusVehicleNumGet200Response>;
    public v1GetButtonStatusVehicleNumGet(vehicleNum: string, loggedInUser?: string, ctryCode?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<V1GetButtonStatusVehicleNumGet200Response>>;
    public v1GetButtonStatusVehicleNumGet(vehicleNum: string, loggedInUser?: string, ctryCode?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<V1GetButtonStatusVehicleNumGet200Response>>;
    public v1GetButtonStatusVehicleNumGet(vehicleNum: string, loggedInUser?: string, ctryCode?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (vehicleNum === null || vehicleNum === undefined) {
            throw new Error('Required parameter vehicleNum was null or undefined when calling v1GetButtonStatusVehicleNumGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (loggedInUser !== undefined && loggedInUser !== null) {
            localVarHeaders = localVarHeaders.set('logged-in-user', String(loggedInUser));
        }
        if (ctryCode !== undefined && ctryCode !== null) {
            localVarHeaders = localVarHeaders.set('ctry-code', String(ctryCode));
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/getButtonStatus/${this.configuration.encodeParam({name: "vehicleNum", value: vehicleNum, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<V1GetButtonStatusVehicleNumGet200Response>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Download Status 
     * Portal get video upload status of bus
     * @param vehicleNum 
     * @param ctryCode 
     * @param loggedInUser 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1GetVideoDownloadStatusVehicleNumGet(vehicleNum: string, ctryCode?: string, loggedInUser?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<V1GetVideoDownloadStatusVehicleNumGet200Response>;
    public v1GetVideoDownloadStatusVehicleNumGet(vehicleNum: string, ctryCode?: string, loggedInUser?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<V1GetVideoDownloadStatusVehicleNumGet200Response>>;
    public v1GetVideoDownloadStatusVehicleNumGet(vehicleNum: string, ctryCode?: string, loggedInUser?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<V1GetVideoDownloadStatusVehicleNumGet200Response>>;
    public v1GetVideoDownloadStatusVehicleNumGet(vehicleNum: string, ctryCode?: string, loggedInUser?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (vehicleNum === null || vehicleNum === undefined) {
            throw new Error('Required parameter vehicleNum was null or undefined when calling v1GetVideoDownloadStatusVehicleNumGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (ctryCode !== undefined && ctryCode !== null) {
            localVarHeaders = localVarHeaders.set('ctry-code', String(ctryCode));
        }
        if (loggedInUser !== undefined && loggedInUser !== null) {
            localVarHeaders = localVarHeaders.set('logged-in-user', String(loggedInUser));
        }

        let localVarCredential: string | undefined;
        // authentication (bearer) required
        localVarCredential = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/getVideoDownloadStatus/${this.configuration.encodeParam({name: "vehicleNum", value: vehicleNum, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<V1GetVideoDownloadStatusVehicleNumGet200Response>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Video To Play
     * Used by bus to get which video is ready to play -  will only return the latest video
     * @param loggedInUser 
     * @param ctryCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1GetVideoToPlayGet(loggedInUser?: string, ctryCode?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<V1GetVideoToPlayGet200Response>;
    public v1GetVideoToPlayGet(loggedInUser?: string, ctryCode?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<V1GetVideoToPlayGet200Response>>;
    public v1GetVideoToPlayGet(loggedInUser?: string, ctryCode?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<V1GetVideoToPlayGet200Response>>;
    public v1GetVideoToPlayGet(loggedInUser?: string, ctryCode?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;
        if (loggedInUser !== undefined && loggedInUser !== null) {
            localVarHeaders = localVarHeaders.set('logged-in-user', String(loggedInUser));
        }
        if (ctryCode !== undefined && ctryCode !== null) {
            localVarHeaders = localVarHeaders.set('ctry-code', String(ctryCode));
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/getVideoToPlay`;
        return this.httpClient.request<V1GetVideoToPlayGet200Response>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Send Button Status
     * Send button status from portal 
     * @param videoId 
     * @param vehicleNum 
     * @param loggedInUser 
     * @param ctryCode 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1SendButtonStatusVideoIdVehicleNumPost(videoId: number, vehicleNum: string, loggedInUser?: string, ctryCode?: string, body?: V1SendButtonStatusVideoIdVehicleNumPostRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<V1SendButtonStatusVideoIdVehicleNumPost200Response>;
    public v1SendButtonStatusVideoIdVehicleNumPost(videoId: number, vehicleNum: string, loggedInUser?: string, ctryCode?: string, body?: V1SendButtonStatusVideoIdVehicleNumPostRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<V1SendButtonStatusVideoIdVehicleNumPost200Response>>;
    public v1SendButtonStatusVideoIdVehicleNumPost(videoId: number, vehicleNum: string, loggedInUser?: string, ctryCode?: string, body?: V1SendButtonStatusVideoIdVehicleNumPostRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<V1SendButtonStatusVideoIdVehicleNumPost200Response>>;
    public v1SendButtonStatusVideoIdVehicleNumPost(videoId: number, vehicleNum: string, loggedInUser?: string, ctryCode?: string, body?: V1SendButtonStatusVideoIdVehicleNumPostRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (videoId === null || videoId === undefined) {
            throw new Error('Required parameter videoId was null or undefined when calling v1SendButtonStatusVideoIdVehicleNumPost.');
        }
        if (vehicleNum === null || vehicleNum === undefined) {
            throw new Error('Required parameter vehicleNum was null or undefined when calling v1SendButtonStatusVideoIdVehicleNumPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (loggedInUser !== undefined && loggedInUser !== null) {
            localVarHeaders = localVarHeaders.set('logged-in-user', String(loggedInUser));
        }
        if (ctryCode !== undefined && ctryCode !== null) {
            localVarHeaders = localVarHeaders.set('ctry-code', String(ctryCode));
        }

        let localVarCredential: string | undefined;
        // authentication (bearer) required
        localVarCredential = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/sendButtonStatus/${this.configuration.encodeParam({name: "videoId", value: videoId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/${this.configuration.encodeParam({name: "vehicleNum", value: vehicleNum, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<V1SendButtonStatusVideoIdVehicleNumPost200Response>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update Flag To Play Video
     * Update Flag To Play Video Based on Video Name, as video name is unique
     * @param videoId 
     * @param ctryCode 
     * @param loggedInUser 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1UpdateFlagOfVideoVideoIdPost(videoId: number, ctryCode?: string, loggedInUser?: string, body?: V1UpdateFlagOfVideoVideoIdPostRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<V1UpdateFlagOfVideoVideoIdPost200Response>;
    public v1UpdateFlagOfVideoVideoIdPost(videoId: number, ctryCode?: string, loggedInUser?: string, body?: V1UpdateFlagOfVideoVideoIdPostRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<V1UpdateFlagOfVideoVideoIdPost200Response>>;
    public v1UpdateFlagOfVideoVideoIdPost(videoId: number, ctryCode?: string, loggedInUser?: string, body?: V1UpdateFlagOfVideoVideoIdPostRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<V1UpdateFlagOfVideoVideoIdPost200Response>>;
    public v1UpdateFlagOfVideoVideoIdPost(videoId: number, ctryCode?: string, loggedInUser?: string, body?: V1UpdateFlagOfVideoVideoIdPostRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (videoId === null || videoId === undefined) {
            throw new Error('Required parameter videoId was null or undefined when calling v1UpdateFlagOfVideoVideoIdPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (ctryCode !== undefined && ctryCode !== null) {
            localVarHeaders = localVarHeaders.set('ctry-code', String(ctryCode));
        }
        if (loggedInUser !== undefined && loggedInUser !== null) {
            localVarHeaders = localVarHeaders.set('logged-in-user', String(loggedInUser));
        }

        let localVarCredential: string | undefined;
        // authentication (bearer) required
        localVarCredential = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/updateFlagOfVideo/${this.configuration.encodeParam({name: "videoId", value: videoId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        return this.httpClient.request<V1UpdateFlagOfVideoVideoIdPost200Response>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update Download Status
     * Bus update download status to portal
     * @param videoName 
     * @param vehicleNum 
     * @param ctryCode 
     * @param loggedInUser 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1UpdateVideoDownloadStatusVideoNameVehicleNumPost(videoName: string, vehicleNum: string, ctryCode?: string, loggedInUser?: string, body?: V1UpdateVideoDownloadStatusVideoNameVehicleNumPostRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<V1UpdateVideoDownloadStatusVideoNameVehicleNumPost200Response>;
    public v1UpdateVideoDownloadStatusVideoNameVehicleNumPost(videoName: string, vehicleNum: string, ctryCode?: string, loggedInUser?: string, body?: V1UpdateVideoDownloadStatusVideoNameVehicleNumPostRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<V1UpdateVideoDownloadStatusVideoNameVehicleNumPost200Response>>;
    public v1UpdateVideoDownloadStatusVideoNameVehicleNumPost(videoName: string, vehicleNum: string, ctryCode?: string, loggedInUser?: string, body?: V1UpdateVideoDownloadStatusVideoNameVehicleNumPostRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<V1UpdateVideoDownloadStatusVideoNameVehicleNumPost200Response>>;
    public v1UpdateVideoDownloadStatusVideoNameVehicleNumPost(videoName: string, vehicleNum: string, ctryCode?: string, loggedInUser?: string, body?: V1UpdateVideoDownloadStatusVideoNameVehicleNumPostRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (videoName === null || videoName === undefined) {
            throw new Error('Required parameter videoName was null or undefined when calling v1UpdateVideoDownloadStatusVideoNameVehicleNumPost.');
        }
        if (vehicleNum === null || vehicleNum === undefined) {
            throw new Error('Required parameter vehicleNum was null or undefined when calling v1UpdateVideoDownloadStatusVideoNameVehicleNumPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (ctryCode !== undefined && ctryCode !== null) {
            localVarHeaders = localVarHeaders.set('ctry-code', String(ctryCode));
        }
        if (loggedInUser !== undefined && loggedInUser !== null) {
            localVarHeaders = localVarHeaders.set('logged-in-user', String(loggedInUser));
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/updateVideoDownloadStatus/${this.configuration.encodeParam({name: "videoName", value: videoName, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/${this.configuration.encodeParam({name: "vehicleNum", value: vehicleNum, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<V1UpdateVideoDownloadStatusVideoNameVehicleNumPost200Response>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Upload Videos
     * @param loggedInUser 
     * @param ctryCode 
     * @param videoFile 
     * @param checksum 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1UploadVideoPost(loggedInUser?: string, ctryCode?: string, videoFile?: Blob, checksum?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<V1UploadVideoPost200Response>;
    public v1UploadVideoPost(loggedInUser?: string, ctryCode?: string, videoFile?: Blob, checksum?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<V1UploadVideoPost200Response>>;
    public v1UploadVideoPost(loggedInUser?: string, ctryCode?: string, videoFile?: Blob, checksum?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<V1UploadVideoPost200Response>>;
    public v1UploadVideoPost(loggedInUser?: string, ctryCode?: string, videoFile?: Blob, checksum?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;
        if (loggedInUser !== undefined && loggedInUser !== null) {
            localVarHeaders = localVarHeaders.set('logged-in-user', String(loggedInUser));
        }
        if (ctryCode !== undefined && ctryCode !== null) {
            localVarHeaders = localVarHeaders.set('ctry-code', String(ctryCode));
        }

        let localVarCredential: string | undefined;
        // authentication (bearer) required
        localVarCredential = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (videoFile !== undefined) {
            localVarFormParams = localVarFormParams.append('videoFile', <any>videoFile) as any || localVarFormParams;
        }
        if (checksum !== undefined) {
            localVarFormParams = localVarFormParams.append('checksum', <any>checksum) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/uploadVideo`;
        return this.httpClient.request<V1UploadVideoPost200Response>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
